import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import ReactPlayer from "react-player";
import { useParams, useHistory } from "react-router-dom";
import swal from "sweetalert";
import cross from "../../../../src/assets/images/Rounds/declined.png";
import tik from "../../../../src/assets/images/Rounds/sign.png";
import "./AuditionRounds.css";
import { Nav, Tab } from "react-bootstrap";
import ReUseableSingleRoundTab from "../../Reuseable/ReUseableSingleRoundTab";
import AuditionApproveFilterVideo from "./AuditionApproveFilterVideo";
import { serverInfo } from "../../../App";
import { useContext } from "react";
import LoaderPost from "../../Reuseable/LoaderPost";
import AuditionAllFilterVideo from "./AuditionAllFilterVideo";
import AuditionRejectFilterVideo from "./AuditionRejectFilterVideo";

const AuditiionRoundVideoFilter = () => {

  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [approveLoading, setApproveLoading] = useState(false);
  const [videoType, setVideoType] = useState("general");
  const [activeRound, setActiveRound] = React.useState(0);
  const [event, setEvent] = useState({});
  const [judges, setJudges] = useState([]);

  const [rounds, setRounds] = useState([]);
  const [videos, setVideos] = useState([]);
  const [allSelectedVideo, setAllSelectedVideo] = useState([]);

  const [allRejectedVideo, setAllRejectedVideo] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState({});
  const [comment, setComment] = useState("");
  const [mark, setMark] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [approveCurrentPage, setApproveCurrentPage] = useState(1);
  const [approveTotalPages, setApproveTotalPages] = useState(1);
  
  const [rejectCurrentPage, setRejectCurrentPage] = useState(1);
  const [rejectTotalPages, setRejectTotalPages] = useState(1);
  

  const [jumpToPage, setJumpToPage] = useState("");

   // API to fetch videos based on the video type and round
  const fetchAllVideos = useCallback(async (url, setVideos, setCurrentPage) => {
    try {
      const response = await axios.get(url);
      if (response.data.status === 200) {
            const videoData = response.data.videos;
            setVideos(videoData);
            setCurrentPage(videoData.current_page);
            setTotalPages(videoData.last_page);
      }
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
  }, []);

    // fetch approve videos
    const fetchApproveVideos = useCallback(async (url, setAllSelectedVideo, setApproveCurrentPage) => {
        try {
            const response = await axios.get(url);
            if (response.data.status === 200) {
                
                    const approveVideoData = response.data.selectedVideos;
                    setAllSelectedVideo(approveVideoData);
                    setApproveCurrentPage(approveVideoData.current_page);
                    setApproveTotalPages(approveVideoData.last_page);

            }
        } catch (error) {
          console.error("Error fetching videos:", error);
        }
  }, []);

     // fetch approve videos
    const fetchRejectVideos = useCallback(async (url, setAllRejectedVideo, setRejectCurrentPage) => {
        try {
           const response = await axios.get(url);
            if (response.data.status === 200) {
                
                    const rejectVideoData = response.data.rejectedVideos;
                    setAllRejectedVideo(rejectVideoData);
                    setRejectCurrentPage(rejectVideoData.current_page);
                    setRejectTotalPages(rejectVideoData.last_page);
            
            }
        } catch (error) {
        console.error("Error fetching videos:", error);
        }
  }, []);

   const fetchRoundVideos = useCallback((round_info_id, page = 1) => {
    const apiUrl = `/api/audition-admin/audition/${videoType === 'general' ? 'videos' : 'appeal-videos'}/${round_info_id}?page=${page}`;
    fetchAllVideos(apiUrl, setVideos, setCurrentPage);
  }, [videoType, fetchAllVideos]);

  const fetchApproveRoundVideos = useCallback((round_info_id, page = 1) => {
    const apiUrl = `/api/audition-admin/audition/${videoType === 'general' ? 'videos' : 'appeal-videos'}/${round_info_id}?page=${page}`;
    fetchApproveVideos(apiUrl, setAllSelectedVideo, setApproveCurrentPage);
  }, [videoType, fetchApproveVideos]);

  const fetchRejectRoundVideos = useCallback((round_info_id, page = 1) => {
    const apiUrl = `/api/audition-admin/audition/${videoType === 'general' ? 'videos' : 'appeal-videos'}/${round_info_id}?page=${page}`;
    fetchRejectVideos(apiUrl, setAllRejectedVideo, setRejectCurrentPage);
  }, [videoType, fetchRejectVideos]);

  // Fetch audition details
  const fetchAuditionDetails = useCallback(async () => {
    try {
      const response = await axios.get(`/api/audition-admin/audition-event/for-round-filter-video/${slug}`);
      if (response.data.status === 200) {
        const event = response.data.event;
        setEvent(event);
        setActiveRound(event.active_round_info_id);
        setRounds(event?.info?.audition_rounds);
        
        const judgesList = event.assigned_judges.map(judge => ({
          name: `${judge?.user.first_name} ${judge?.user.last_name}`,
          id: judge?.user.id,
        }));
        setJudges(judgesList);
        
        fetchRoundVideos(event.active_round_info_id);
      }
    } catch (error) {
      console.error("Error fetching audition details:", error);
    } finally {
      setLoading(false);
    }
  }, [slug, fetchRoundVideos]);


  const handleAppealedVideos = () => {
    setVideoType("appeal");
  };

  const handleGeneralVideos = () => {
    setVideoType("general");
  };

  
  useEffect(() => {
    fetchAuditionDetails();
  }, [fetchAuditionDetails]);

  useEffect(() => {
    fetchRoundVideos(activeRound, currentPage);
  }, [videoType, activeRound, currentPage, fetchRoundVideos]);

  useEffect(() => {
    fetchApproveRoundVideos(activeRound, approveCurrentPage);
  }, [videoType, activeRound, approveCurrentPage, fetchApproveRoundVideos]);

  useEffect(() => {
    fetchRejectRoundVideos(activeRound, rejectCurrentPage);
  }, [videoType, activeRound, rejectCurrentPage, fetchRejectRoundVideos]);



  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchRoundVideos(activeRound, page);
  };

  const handleApprovePageChange = (page) => {
    setApproveCurrentPage(page);
    fetchApproveRoundVideos(activeRound, page);
  }

  const handleRejectPageChange = (page) => {
    setRejectCurrentPage(page);
    fetchRejectRoundVideos(activeRound, page);
  }


  const activeRoundHadler = (id) => {
    setActiveRound(id);
    fetchRoundVideos(id, 1); // Reset to page 1 on round change
  };

  const handleSelectedVideo = (event) => {
    setSelectedVideo(event);
  };

  const approvalHandler = () => {
    if (selectedVideo.id) {
      setApproveLoading(true)
      const fData = new FormData();
      fData.append("comment", comment);


      axios.post(`/api/audition-admin/audition/videos/set_approved/${selectedVideo.id}`, fData)
        .then((res) => {
          if (res.data.status === 200) {
            setMark(0);
            setComment("");
            fetchRoundVideos(activeRound, currentPage);
            fetchApproveRoundVideos(activeRound, approveCurrentPage);
            setApproveLoading(false)
          }
        });
    } else {
      swal("Whoops...", "Please select a video first", "error");
    }
  };

  const rejectHandler = () => {
    if (comment === "") {
      swal("Warning", "Comment Required", "warning");
    } else {
      const fData = new FormData();
      fData.append("comment", comment);

      axios.post(`/api/audition-admin/audition/videos/set_reject/${selectedVideo.id}`, fData)
        .then((res) => {
          if (res.data.status === 200) {
            setComment("");
            fetchRoundVideos(activeRound, currentPage);
            fetchRejectRoundVideos(activeRound, rejectCurrentPage);
          }
        });
    }
  };

  const handleJumpToPage = (e) => {
    const page = e.target.value;
    if (!isNaN(page) && Number(page) > 0) {
      setJumpToPage(page);
      console.log(page);
    }
  };

  const handleJumpToPageSubmit = () => {
    const pageNumber = parseInt(jumpToPage);
    if (pageNumber && pageNumber > 0) {
      setCurrentPage(pageNumber);
      fetchRoundVideos(activeRound, pageNumber);
      setJumpToPage(pageNumber);

      history.push(`?page=${pageNumber}`);
    }
  };



  return (
    <>
      {loading ? (
        <LoaderPost />
      ) : (
        <>
          <div>
            <Tab.Container id="left-tabs-example" defaultActiveKey={activeRound}>
              <div className="container-lg">
                <Nav variant="pills">
                  <div className="row">
                    {rounds && rounds.map((auditionRound, index) => (
                      <ReUseableSingleRoundTab
                        key={index}
                        auditionRound={auditionRound}
                        setActiveRound={activeRoundHadler}
                      />
                    ))}
                  </div>
                </Nav>
                <div className="my-4"></div>
              </div>
            </Tab.Container>
          </div>

          <div>
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Nav variant="pills" className="d-flex justify-content-center">
                <div className="col-md-md-6 small-live-session mb-3">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="first"
                      className="TabCardGold d-flex text-decoration-none text-center me-2 fw-bold pt-3"
                      onClick={handleGeneralVideos}
                    >
                      <h5 className="font-style fw-bold">General Videos</h5>
                    </Nav.Link>
                  </Nav.Item>
                </div>
                <div className="col-md-md-6 small-live-session">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="second"
                      className="TabCardGold py-2 fw-bold pt-3 text-decoration-none text-center"
                      onClick={handleAppealedVideos}
                    >
                      <h5 className="font-style fw-bold">Appealed Videos</h5>
                    </Nav.Link>
                  </Nav.Item>
                </div>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="first"></Tab.Pane>
                <Tab.Pane eventKey="second"></Tab.Pane>
              </Tab.Content>
            </Tab.Container>

            <div className="row mt-3 me-2">
              <div className="card card-bg head-line mt-2 mb-2">
                <div className="text-light">
                  <h4 className="mx-3 text-white fw-bolder text-center p-2">
                    All User Videos
                  </h4>
                </div>
              </div>

              <div className="my-3">
                <AuditionAllFilterVideo
                  data={videos}
                  handleSelectedVideo={handleSelectedVideo}
                  selectedVideo={selectedVideo}
                  handlePageChange={handlePageChange}
                  handleJumpToPage={handleJumpToPage}
                  handleJumpToPageSubmit={handleJumpToPageSubmit}
                  jumpToPage={jumpToPage}
                  setJumpToPage={setJumpToPage}
                />
              </div>
              <div className="row py-4 justify-content-md-center align-items-center card-bg mx-1 pt-5">
                <div className="col-md-3 mb-4 d-flex justify-content-md-between align-items-center">
                  <button
                    disabled={approveLoading}
                    className="text-dark fw-bold btnSuccess btn"
                    onClick={approvalHandler}
                  >
                    {approveLoading ? 'Loading...': 'Approve'} &nbsp;
                    <img src={tik} alt="" width="30px" />
                  </button>
                </div>

                <div className="row col-md-9 mb-4 d-flex justify-content-md-between align-items-center">
                  <div className="col-md-8 mb-3">
                    <input
                      type="text"
                      className="form-control reply-control"
                      placeholder="Write Comment Here...."
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 mb-3 d-flex justify-content-md-center">
                    <button
                      className="text-light btnDecline  fw-bold  btn "
                      onClick={rejectHandler}
                    >
                      Reject &nbsp;
                      <img src={cross} alt="" width="30px" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="my-3">
                <div className="card card-bg head-line mt-2 mb-2">
                  <div className="text-light">
                    <h4
                      style={{ color: "rgb(110, 231, 183)" }}
                      className="mx-3 fw-bolder text-center p-2"
                    >
                      Approved Videos (
                      {allSelectedVideo && allSelectedVideo?.total})
                    </h4>
                  </div>
                </div>
                {/* <h5 className="text-light">
                  Approved Videos ({allSelectedVideo && allSelectedVideo.length}
                  )
                </h5> */}
                <div className="">
                  <AuditionApproveFilterVideo
                    data={allSelectedVideo}
                    handleSelectedVideo={handleSelectedVideo}
                    handlePageChange={handleApprovePageChange}
                  />
                </div>
              </div>


              <div className="my-3">
                <div className="card card-bg head-line mt-2 mb-2">
                  <div className="text-light">
                    <h4
                      style={{ color: "rgb(251 113 133)" }}
                      className="mx-3 fw-bolder text-center p-2"
                    >
                      Rejected Videos (
                      {allRejectedVideo && allRejectedVideo?.total})
                    </h4>
                  </div>
                </div>
                {/* <h5 className="text-danger">
                  Rejected Videos ({allRejectedVideo && allRejectedVideo.length}
                  )
                </h5> */}
                <div className="">
                  <AuditionRejectFilterVideo
                    data={allRejectedVideo}
                    handleSelectedVideo={handleSelectedVideo}
                    handlePageChange={handleRejectPageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AuditiionRoundVideoFilter;
